Vue.component('date-picker', {
    template: '<input type="text" name="departureDate" readonly="readonly"  class="datepicker hasDatePickerDepartureDate required dateTr tripleDateBoundries"/>',
    data: function () {
        return {

        }
    },
    mounted: function(){
        this.createDatePicker();
    },
    methods:{
        createDatePicker: function() {
            this.datepickerGoToToday();

            var datePickerDateFormat = "dd.mm.yy";
            var vm = this;

            var now = new Date();
            var aYearLater = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

            var datepicker = $('.datepicker').datepicker({
                dateFormat : datePickerDateFormat,
                numberOfMonths : 1,
                showButtonPanel: true,
                closeText: "x",
                minDate : now,
                maxDate : aYearLater,
                onSelect : function(dateText, inst) {
                    var date = $.datepicker.parseDate(datePickerDateFormat, dateText.substr(0,10));
                    date = $.datepicker.formatDate(datePickerDateFormat, date)
                    vm.$emit('input', date);
                },
            });
            datepicker.val($.datepicker.formatDate(datePickerDateFormat, now));
            this.$emit('input', $.datepicker.formatDate(datePickerDateFormat, now));
        },

        datepickerGoToToday: function(){

            var o_gotoToday = $.datepicker._gotoToday;

            $.datepicker._gotoToday = function(id) {

                o_gotoToday.call(this, id);
                var date = new Date();
                var selDate  = this.formatDate("dd.mm.yy", date);
                this._selectDate(id, selDate);

            }
    },
}
});